module.exports = __webpack_public_path__ + "static/media/cowork.25f2f537.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cowork.png
// module id = 383
// module chunks = 1